// i18n area 'tasks' — locale sv-SE (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.sv-SE.meta.json.
import type { enUS } from './tasks'

export const svSE: typeof enUS = {
  macrotasks: {
    title: 'Macrotasks',
    subtitle: 'Sammansatta operationer — återupptagbara från det misslyckade steget, eller avbrytbara',
    colType: 'Typ',
    colTarget: 'Objekt',
    colPhase: 'Fas',
    colSteps: 'Steg',
    empty: 'Ingen macrotask',
    detail: 'Detaljer',
    failedAt: 'misslyckades vid',
    resume: 'Försök igen från det misslyckade steget',
    abort: 'Avbryt allt',
    cancel: 'Annullera',
    actionError: 'Åtgärden avvisades'
  },
  tasks: {
    title: 'Tasks',
    searchPlaceholder: 'Sök på typ eller target',
    type: 'Typ',
    target: 'Target',
    phaseLabel: 'Fas',
    progress: 'Förlopp',
    started: 'Startad',
    finished: 'Avslutad',
    node: 'Nod',
    empty: 'Ingen task',
    loadError: 'Kunde inte läsa in taskarna — är TVirt-backenden nåbar?',
    limboHint: "Noden '{node}' onåbar sedan {time} — tasken håller kvar write-leaset på sitt target tills noden kommer tillbaka eller attesteras avstängd",
    nodeAttested: 'Noden attesterad avstängd',
    phase: {
      queued: 'I kö',
      running: 'Kör',
      succeeded: 'Slutförd',
      failed: 'Misslyckad',
      cancelled: 'Annullerad',
      'failed-at-step': 'Misslyckad vid ett steg',
      aborted: 'Avbruten'
    },
    dropdown: {
      tooltip: 'Pågående tasks',
      title: 'Pågående tasks',
      empty: 'Ingen pågående task',
      viewAll: 'Se alla tasks'
    },
    detail: {
      open: 'Detaljer',
      scope: 'Omfång',
      message: 'Meddelande',
      params: 'Parametrar',
      result: 'Resultat',
      errorTitle: 'Fel',
      steps: 'Steg',
      failedAt: 'misslyckades vid',
      superseded: 'ersatt',
      step: 'Steg',
      parent: 'Förälder-task',
      failedStep: 'Misslyckat steg',
      log: 'Logg',
      logEmpty: 'Ännu ingen loggrad',
      close: 'Stäng'
    },
    actions: {
      cancel: 'Annullera',
      resume: 'Försök igen från det misslyckade steget',
      abort: 'Avbryt allt (undo av de slutförda stegen)',
      refused: 'Åtgärden avvisades'
    }
  },
  events: {
    loadError: 'Kunde inte ladda journalen — är TVirt-backenden nåbar?',
    title: 'Händelser',
    subtitle: 'Klustrets historiska minne: fullbordade fakta, nyaste först',
    filterSeverity: 'Allvarlighetsgrad',
    filterCategory: 'Kategori',
    filterAll: 'Alla',
    searchLabel: 'Sök',
    searchPlaceholder: 'Sök i hela journalen',
    subjectFilter: 'Händelser för {subject} — visa alla',
    colAt: 'När',
    colSeverity: 'Allvarlighetsgrad',
    colType: 'Typ',
    colSubject: 'Objekt',
    colActor: 'Vem',
    colNode: 'Node',
    colMessage: 'Meddelande',
    empty: 'Inga händelser',
    loadMore: 'Ladda fler',
    actorSystem: 'system',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Händelse-ID',
    taskCollectedHint: 'Task har kortare lagringstid: när den samlats in svarar länken inte längre',
    severity: {
      info: 'Info',
      warning: 'Varning',
      error: 'Fel',
      critical: 'Kritisk'
    },
    category: {
      lifecycle: 'Livscykel',
      config: 'Konfiguration',
      availability: 'Tillgänglighet',
      security: 'Säkerhet'
    },
    type: {
      haNetsvcFailedOver: 'Failover av nätverkstjänsten',
      haNetsvcNoCandidate: 'Nätverkstjänst utan kandidatnod',
      haNetsvcReaped: 'Lokal instans skördad vid återanslutningen',
      netsvcFloatipMoved: 'Flytande IP flyttad till en annan hållare',
      netsvcFloatipNoHolder: 'Flytande IP utan friskt mål',
      haAppFailedOver: 'Failover av App-instans',
      haAppNoCandidate: 'App-instans utan kandidatnod',
      haAppStorageLocalSkip: 'App-instans inte flyttad: beständiga data lokala på den döda noden',
      haAppReaped: 'App-instansens lokala pod skördad vid återinträde'
    }
  },
  audit: {
    loadError: 'Kunde inte ladda auditregistret — är TVirt-backenden nåbar?',
    title: 'Audit',
    subtitle: 'Vem gjorde vad, när och på vilket objekt — försökta handlingar, avslag inräknade',
    filterOutcome: 'Utfall',
    filterAll: 'Alla',
    filterSudo: 'Endast förhöjda handlingar',
    colAt: 'När',
    colActor: 'Vem',
    colAction: 'Åtgärd',
    colTarget: 'Objekt',
    colOutcome: 'Utfall',
    colNode: 'Node',
    empty: 'Inga registrerade handlingar',
    loadMore: 'Ladda fler',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Rutt',
    detailProblem: 'Orsak',
    detailTask: 'Task',
    detailClientIp: 'Från',
    detailId: 'Post-ID',
    detailSession: 'Session',
    taskHint: 'Utfallet av en accepterad handling lever i händelsejournalen, under samma task-id',
    outcome: {
      succeeded: 'Utförd',
      accepted: 'Accepterad',
      denied: 'Nekad',
      rejected: 'Avvisad',
      failed: 'Misslyckad'
    }
  },
  notifications: {
    loadError: 'Kunde inte ladda notifieringarna — är TVirt-backenden nåbar?',
    actionError: 'Åtgärden avvisades',
    title: 'Notifieringar',
    subtitle: 'Destinationerna som journalens fakta lämnar klustret mot',
    rulesTitle: 'Regler',
    rulesSubtitle: 'Vilka fakta som går ut, och vart',
    deliveriesTitle: 'Leveranser',
    deliveriesSubtitle: 'Resultatet av varje notifiering, med orsaken när den misslyckas',
    colName: 'Namn',
    colKind: 'Typ',
    colWhere: 'Vart',
    colScope: 'Scope',
    colSeverity: 'Allvarlighetsgrad',
    colMatch: 'Filter',
    colTargets: 'Destination',
    colAt: 'När',
    colState: 'Tillstånd',
    colEvent: 'Händelse',
    colAttempts: 'Försök',
    colOutcome: 'Resultat',
    empty: 'Ingen rad',
    matchAll: 'alla fakta',
    test: 'Testa',
    testOk: 'Testnotifiering levererad till {target}',
    testFailed: 'Test mot {target} misslyckades: {reason}',
    retry: 'Köa om',
    retried: 'Leverans köad om',
    grouped: 'och {count} fler upprepningar',
    state: {
      failed: 'Misslyckad',
      pending: 'I kö',
      sending: 'Skickas',
      sent: 'Skickad'
    },
    tabTargets: 'Destinationer',
    tabRules: 'Regler',
    tabDeliveries: 'Leveranser',
    targetCreateTitle: 'Ny destination',
    ruleCreateTitle: 'Ny regel',
    nameHint: 'Små bokstäver, siffror och bindestreck; unikt per scope',
    kindImmutableHint: 'Oföränderlig: att byta typ betyder att skapa en annan destination',
    kindSmtp: 'Post (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Status',
    enabledOn: 'Aktiv',
    enabledOff: 'Pausad',
    smtpHost: 'SMTP-server',
    smtpPort: 'Port',
    smtpPortHint: 'Vanligt: 25 utan TLS, 587 med starttls, 465 med tls',
    smtpSecurity: 'Säkerhet',
    smtpFrom: 'Avsändare',
    smtpTo: 'Mottagare',
    smtpToHint: 'En eller flera adresser separerade med kommatecken',
    webhookUrl: 'URL',
    payload: 'Innehåll',
    payloadHint: 'Med minimal lämnar händelsens meddelande och data aldrig klustret',
    credential: 'Autentiseringsuppgift',
    credentialNone: 'Ingen',
    credentialHintSmtp: 'Relärkontot från nyckelvalvet; ingen betyder anonym SMTP',
    credentialHintWebhook: 'Signeringshemligheten från nyckelvalvet; utan signering kan var och en som känner URL:en utge sig för att vara klustret',
    minSeverityHint: 'En tröskel, inte en mängd: från denna allvarlighetsgrad och uppåt',
    categories: 'Kategorier',
    categoriesHint: 'Tomt = alla',
    types: 'Händelsetyper',
    typesHint: 'Separerade med kommatecken; tomt = alla. En okänd typ avvisas',
    targetsHint: 'Minst en; de måste ligga i regelns scope eller i en förfader till det',
    recursiveOn: 'Även underordnade scope',
    recursiveOff: 'Endast detta scope',
    recursiveHint: 'Resurser lever i löven: utan barnen aviserar en regel på roten nästan ingenting',
    repeatWindow: 'Grupperingsfönster (s)',
    repeatWindowHint: 'Inom fönstret skickar upprepningar ingen post: de räknas på den första. 0 stänger av',
    targetInUseError: 'Destinationen {name} används fortfarande av en regel'
  }
}
